import { checkWorkspace, WORKSPACES_REPSOL } from 'guards/CheckRoles';
import { Fragment } from 'react';
import { RootState, useSelector } from './../../redux/store';
import DeviceDetails from './DeviceDetails';
import DeviceDetailsDashboard from './DeviceDetailsDashboard';
function DeviceDetailsEndUser() {
  const { workspace } = useSelector((state: RootState) => state.workspace);

  return (
    <Fragment>
      {checkWorkspace(workspace, WORKSPACES_REPSOL) && <DeviceDetails></DeviceDetails>}
      {!checkWorkspace(workspace, WORKSPACES_REPSOL) && workspace?.wsName && (
        <DeviceDetails></DeviceDetails>
      )}
    </Fragment>
  );
}

export default DeviceDetailsEndUser;
